import { concatMap, map, tap } from 'rxjs';
import { getStore } from '@store';
import { setLanguage } from '@store/slices/common.slice';
import { LanguageCode } from '@models';
import { HttpServiceBase, RxUtils, TypeUtils } from '@utils';
import { httpService } from '@services/http';
import { logger } from '@services/logger';
import { UserPreferences } from './user-preferences.class';

export class UserPreferencesService extends HttpServiceBase {
	private store = getStore().store;
	constructor() {
		super('user-preferences');
	}

	find() {
		return httpService.get<UserPreferences>(this.getUrl()).pipe(
			concatMap((result) => RxUtils.valueOrThrow(result, new Error('Response is empty'))),
			map((result) => TypeUtils.convert(UserPreferences, result)),
			tap((result) => logger.debug(`[${this.constructor.name}.${this.find.name}]`, result)),
			map((result) => {
				result?.language &&
					Object.values(LanguageCode).includes(result.language) &&
					this.store.dispatch(setLanguage(result.language));
				return result;
			})
		);
	}

	update(entity: Partial<UserPreferences>) {
		return httpService.patch<UserPreferences>(this.getUrl(), ``, { body: entity }).pipe(
			concatMap((result) => RxUtils.valueOrThrow(result, new Error('Response is empty'))),
			map((result) => TypeUtils.convert(UserPreferences, result)),
			tap((result) => logger.debug(`[${this.constructor.name}.${this.update.name}]`, result)),
			concatMap(() => this.find())
		);
	}
}

export const userPreferencesService = new UserPreferencesService();
